module.exports = __webpack_public_path__ + "static/shopify-5f1ba177875c59dd77099e35acbea800.png";